import { REVIEW_STATUS } from '@/constants/reviewStatus'
import { isEqual } from 'lodash-es'
export default {
  methods: {
    _countFilters (filters) {
      let count = 0
      if (!this.expenses && filters['card.user.id']) {
        count++
      }
      if (filters['exists[accountedAt]'] !== undefined) {
        count++
      }
      if (!isNaN(filters['absAmount[gte]']) || !isNaN(filters['absAmount[lte]'])) {
        count++
      }

      if (typeof filters['isCompleted'] === 'boolean') {
        count++
      }
      const hasManualReviewStatusCodeFilters = isEqual(filters['reviewStatus.code'], [REVIEW_STATUS.APPROVED]) || isEqual(filters['reviewStatus.code'], [REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.OFFICE_FLOW_REVISION])
      const hasAnyRreviewStatusAndNextFlowStepId = filters['withReviewFlow'] === false || (filters['reviewStatusAndNextFlowStepId'] && filters['reviewStatusAndNextFlowStepId'].length > 0 && !(filters['reviewStatusAndNextFlowStepId'].includes(REVIEW_STATUS.APPROVED) && typeof filters['isPersonalExpense'] === 'boolean'))

      if (hasManualReviewStatusCodeFilters || hasAnyRreviewStatusAndNextFlowStepId) {
        count++
      }
      if (typeof filters['isPersonalExpense'] === 'boolean') {
        count++
      }
      if (typeof filters['withWarnings'] === 'boolean') {
        count++
      }

      if (filters['expense.paymentMethod.officePaymentMethod.id']) {
        count++
      }
      if (filters['budget.id'] && !this.hideBudget) {
        count++
      }

      if (filters['defaultCategoryOffice.id'] || filters['customCategory.id']) {
        count++
      }
      if (filters['card.office.customer.id']) {
        count++
      }

      if (filters['receipt.accountingDate[after]'] || filters['receipt.accountingDate[before]']) {
        count++
      }

      if (!isNaN(filters['receipt.taxBase1[gt]']) ||
        !isNaN(filters['receipt.taxBase2[gt]']) ||
        !isNaN(filters['receipt.taxBase3[gt]']) ||
        !isNaN(filters['receipt.taxBase4[gt]'])
      ) {
        count++
      }
      if (filters['receipt.type']) {
        count++
      }

      return count
    }

  }
}
